import { getCurrentLangFromRedux, getDir } from "../../algorithms/styleChanges";
import {
  contentEnd,
  contentStart,
  customStyle,
  styleEnd,
  styleStart,
} from "../../algorithms/styleDirection";
import Icon from "../sharedComponents/icons/fontawsomeIcons";
import { Link } from "react-router-dom";
import "moment/locale/ar";
import Lang from "../../userPreferences/staticWords";
import { useEffect, useState } from "react";
import { paths } from "../../paths/paths";
import ModalComponent from "../reusableComponents/modal";
import AddProcedureForm from "./addProcedure/addProcedureForm";
import { formatDatelll } from "../../algorithms";
import { formatDateLL } from "./../../algorithms/index";
import TaskStatus from "./taskStatus/taskStatus";
import { getEditDataTaskForm } from "../../API/store/actions/tasks";
import EditTaskForm from "./editTask/editTaskForm";
import { resolver } from "../../API/middlewares/resolveRequests";
import AddTaskAttachments from "./addTaskAttachmentPopup";
import DeleteProcAlert from "./editProc.js/deleteProc";
import { useSelector } from "react-redux";
import "../layout/layoutStyle.css";
import Loading from "./../reusableComponents/loading";
import ReactTooltip from "react-tooltip";

const TaskCard = ({
  TasksWithProcedures,
  setProcAdded,
  procAdded,
  userToken,
  communityId,
  currentPage,
}) => {
  const userLogged = useSelector((state) => state.login.userData);
  const [show, setshow] = useState({ id: null, display: false });
  //for slicing content
  // let slicedBrief = item.brief;
  // if (item.brief !== null && item.brief.length > 150) {
  //   const brief = item.brief;
  //   slicedBrief = brief.substring(0, 140).concat(" ...");
  // }
  // const id = TasksWithProcedures?.data.id;
  // const taskStatus = TasksWithProcedures?.data?.taskStatus?.id;
  const [visibleProc, setVisibleProc] = useState(false);
  const [visibleStatus, setVisibleStatus] = useState(false);
  const [visibleEdit, setVisibleEdit] = useState(false);
  const [taskId, setTaskId] = useState(null);
  const [taskTitle, setTaskTitle] = useState(null);
  const community = useSelector((state) => state.community.communityId);
  const [showAttachmentPopup, setShowAttachmentPopup] = useState(false);
  const onShowAttachments = () => {
    setShowAttachmentPopup(true);
  };
  const renderAttachmentsModal = (taskId) => {
    return (
      <AddTaskAttachments
        userToken={userToken}
        procAdded={procAdded}
        setProcAdded={setProcAdded}
        taskId={taskId}
        show={showAttachmentPopup}
        onHide={() => setShowAttachmentPopup(false)}
      />
    );
  };

  const [deleteModalVisible, setDeleteModalVisible] = useState(false);

  const [data, setData] = useState(null);
  console.log(data);
  useEffect(() => {
    if (data) setVisibleEdit(true);
  }, [data]);

  document.onclick = function (event) {
    if (
      !event.target.matches(".icon") &&
      !event.target.matches(".icon svg path")
    ) {
      var sharedowns = document.getElementsByClassName(
        `${customStyle("dropdown-menu")}`,
      );
      for (let i = 0; i < sharedowns?.length; i++) {
        var openSharedown = sharedowns[i];
        if (openSharedown?.classList?.contains("show")) {
          openSharedown?.classList?.remove("show");
          setshow({ id: null, display: false });
        }
      }
    }
  };

  // ActivitiesWithProcedures?.length > 0;
  if (TasksWithProcedures?.data) {
    return (
      <>
        <ModalComponent
          body={
            <EditTaskForm
              taskTitle={taskTitle}
              taskId={taskId}
              setVisible={setVisibleEdit}
              data={data?.data}
              setProcAdded={setProcAdded}
              procAdded={procAdded}
              userToken={userToken}
            />
          }
          hasImage={
            <img
              src="/assets/images/greeniconedit.svg"
              width={20}
              height={20}
              alt=""
            />
          }
          setModalVisible={setVisibleEdit}
          modalVisible={visibleEdit}
          size={"xl"}
          title={Lang.editTask}
        />

        <ModalComponent
          body={
            <TaskStatus
              userToken={userToken}
              taskTitle={taskTitle}
              taskId={taskId}
              setVisible={setVisibleStatus}
              setProcAdded={setProcAdded}
              procAdded={procAdded}
            />
          }
          // hasImage={
          //   <img
          //     src="/assets/images/icons/status.png"
          //     width={20}
          //     height={20}
          //     alt=""
          //   />
          // }
          setModalVisible={setVisibleStatus}
          modalVisible={visibleStatus}
          size={"xl"}
          title={"تغيير حالة الإجراء"}
        />
        <ModalComponent
          body={
            <AddProcedureForm
              userToken={userToken}
              taskId={taskId}
              setVisible={setVisibleProc}
              setProcAdded={setProcAdded}
              procAdded={procAdded}
            />
          }
          hasImage={
            <div
              style={{
                backgroundColor: "#0c574b",
                height: 26,
                width: 26,
                cursor: "pointer",
                borderRadius: "50%",
              }}
              className="d-flex justify-content-center text-center align-items-center itemNav plusIcon"
            >
              <div
                style={{
                  width: 16,
                  height: 16,
                  background:
                    "url('/assets/images/icons/Path 184.png') 0% 0% no-repeat padding-box",
                  opacity: 1,
                  filter: "opacity(1) brightness(20)",
                }}
                className="any"
              ></div>
            </div>
          }
          setModalVisible={setVisibleProc}
          modalVisible={visibleProc}
          size={"xl"}
          title={Lang.addcomments}
        />
        <ModalComponent
          body={
            <DeleteProcAlert
              userToken={userToken}
              setProcAdded={setProcAdded}
              procAdded={procAdded}
              taskId={taskId}
              setVisible={setDeleteModalVisible}
              content={"هل تريد حذف الإجراء"}
            />
          }
          size={"s"}
          modalVisible={deleteModalVisible}
          setModalVisible={setDeleteModalVisible}
          hasImage={
            <img
              src="/assets/images/deleteicon.png"
              width={20}
              height={20}
              alt=""
            />
          }
          title={"هل انت متاكد"}
          background={"modalBackground mx-5"}
        />
        <div
          className={`d-flex flex-column align-self-center col-lg-8 col-10 ${styleStart(
            "m",
            4,
            "lg",
          )} mx-0`}
        >
          {TasksWithProcedures?.data.map((item, index) => {
            let newCreateDate, userPhoto;
            if (item?.procedure)
              newCreateDate = item.procedure.createDate.split(".")[0];
            if (item?.procedure?.memberPhoto != null)
              userPhoto = `url("${paths.MemberPhoto}${item.procedure.memberId}/${item.procedure.memberPhoto}")`;
            else userPhoto = `url("/assets/images/userPlaceholder.png")`;
            const isOverdue =
              item?.taskStatus?.id === 5 &&
              item?.endDate &&
              new Date(item.endDate) < new Date();

            const taskStatusName = isOverdue
              ? " متأخر"
              : item?.taskStatus?.name;
            const taskStatusColor = isOverdue
              ? "#dc3545"
              : item?.taskStatus?.color;
            return (
              <div
                className="d-flex flex-column col-12 mt-4 taskCard"
                style={{
                  border: "1px solid #C7C7C9",
                  borderRadius: 10,
                  height: "fit-content",
                }}
                key={item.id}
              >
                {/* title */}
                <div className="d-flex align-items-start px-4 pt-2 pb-1">
                  <div
                    className={`d-flex justify-content-center align-items-center col-1 ${styleEnd(
                      "m",
                      2,
                    )}`}
                    style={{
                      border: "1px solid rgb(12, 87, 76)",
                      borderRadius: "50%",
                      width: 27,
                      height: 27,
                      fontSize: 12,
                    }}
                  >
                    {index + 1 + (currentPage - 1) * 20}
                    {/* {item?.id} */}
                  </div>
                  <Link
                    className={`my-0 ${styleEnd(
                      "m",
                      3,
                    )} text-decoration-none text-dark`}
                    style={{
                      lineHeight: 1.5,
                      fontSize: 18,
                      fontWeight: "bold",
                    }}
                    to={`/taskDetails/${item.id}`}
                  >
                    {item.name}
                  </Link>

                  <div className="col d-flex justify-content-end align-items-start btn-group">
                    {show.id == item.id ? (
                      <>
                        <div
                          style={{ display: show.display ? "block" : "none" }}
                          className={`${customStyle("arrow-horizontal")} ${
                            show.display ? "show" : ""
                          }`}
                        ></div>
                        <ul
                          className={`${customStyle("dropdown-menu")} ${
                            show.display ? "show" : ""
                          }`}
                          style={{
                            display: show.display ? "block" : "none",
                          }}
                        >
                          {userLogged?.isAdmin && (
                            <li
                              style={{ cursor: "pointer" }}
                              id={item.id}
                              onClick={(e) => {
                                const currentId = e.currentTarget.id;
                                resolver(
                                  getEditDataTaskForm,
                                  setData,
                                  currentId,
                                  communityId,
                                  userToken,
                                );
                                setTaskId(currentId);
                              }}
                            >
                              <span
                                className={`dropdown-item ${customStyle(
                                  "dropdown-item",
                                )}`}
                              >
                                تعديل الإجراء
                              </span>
                            </li>
                          )}
                          {!userLogged?.isAdmin && (
                            <li style={{ cursor: "pointer" }} id={item.id}>
                              <span
                                onClick={(e) => {
                                  setTaskId(item.id);
                                  setTaskTitle(item.name);
                                  setVisibleStatus(true);
                                  // const currentId = e.currentTarget.id;
                                  // resolver(
                                  //   getEditDataTaskForm,
                                  //   setData,
                                  //   currentId,
                                  //   communityId,
                                  //   userToken
                                  // );
                                  // setTaskId(currentId);
                                }}
                                className={`dropdown-item ${customStyle(
                                  "dropdown-item",
                                )}`}
                              >
                                تعديل حالة الإجراء
                              </span>
                            </li>
                          )}

                          <li
                            style={{ cursor: "pointer" }}
                            id={item.id}
                            onClick={(e) => {
                              const currentId = e.currentTarget.id;
                              setTaskId(currentId);
                              onShowAttachments();
                            }}
                          >
                            <span
                              className={`dropdown-item ${customStyle(
                                "dropdown-item",
                              )}`}
                            >
                              اضافة مرفقات
                            </span>
                          </li>
                          {userLogged?.isAdmin && (
                            <li
                              style={{ cursor: "pointer" }}
                              id={item.id}
                              onClick={(e) => {
                                const currentId = e.currentTarget.id;
                                setTaskId(currentId);
                                setDeleteModalVisible(true);
                              }}
                            >
                              <span
                                className={`dropdown-item ${customStyle(
                                  "dropdown-item",
                                )}`}
                              >
                                حذف الإجراء
                              </span>
                            </li>
                          )}
                        </ul>
                      </>
                    ) : null}
                  </div>

                  <Icon
                    id={item.id}
                    name="ellipsis-v"
                    size={18}
                    className="icon"
                    onclick={(e) => {
                      const id = e.currentTarget.id;
                      id == null
                        ? setshow({
                            id,
                            display: true,
                          })
                        : id == show.id
                          ? setshow({
                              id: null,
                              display: false,
                            })
                          : setshow({
                              id,
                              display: true,
                            });
                    }}
                  />
                </div>
                <p className="text-muted px-4 ">
                  {item?.adminMembers[0]?.memberName}
                </p>
                {/* date */}
                <div className="d-flex align-items-center px-4">
                  <p className="text-muted" style={{ fontSize: 14 }}>
                    {Lang.inPeriod}
                    <span>
                      &nbsp;&nbsp;&nbsp;{Lang.from}{" "}
                      {`${formatDateLL(item.startDate)}`}
                    </span>{" "}
                    <span>
                      &nbsp;&nbsp;&nbsp;{Lang.to}{" "}
                      {`${formatDateLL(item.endDate)}`}
                    </span>
                  </p>
                </div>

                {/* icons */}
                <div className="d-flex flex-wrap align-items-center px-4 py-2">
                  {/* <div
                    className={`d-flex justify-content-center py-2 px-3 ${styleEnd(
                      "m",
                      2
                    )} mb-2`}
                    style={{
                      backgroundColor: "#F2F2F2",
                      width: "fit-content",
                      borderRadius: 10,
                    }}
                  >
                    <div className={`${styleEnd("m", 2)}`}>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16.883"
                        height="18"
                        viewBox="0 0 16.883 18"
                      >
                        <path
                          id="_001-clock"
                          data-name="001-clock"
                          d="M8.442,18.25C.949,18.242-2.821,8.53,2.473,2.871a8.107,8.107,0,0,1,11.938,0C19.7,8.531,15.934,18.242,8.442,18.25Zm0-16.61a7.382,7.382,0,0,0-7.123,7.6c.391,10.084,13.855,10.081,14.245,0A7.382,7.382,0,0,0,8.442,1.64Zm3.071,9.884L9.429,9.3A1.092,1.092,0,0,0,9.1,8.454c0-.007,0-.015,0-.022V4.314a.661.661,0,1,0-1.319,0V8.432c0,.007,0,.015,0,.022A1.066,1.066,0,0,0,8.5,10.3l2.084,2.224a.631.631,0,0,0,.933,0,.738.738,0,0,0,0-1Z"
                          transform="translate(0 -0.25)"
                          fill={item?.dayCount?.color ?? "#3ec4b8"}
                        />
                      </svg>
                    </div>
                    <div className="d-flex align-items-center justify-content-center">
                      <p className="my-0">
                        {item.dayCount.day >= 0 ? item.dayCount.day : ""}&nbsp;
                        {item.dayCount.daystatus}
                      </p>
                    </div>
                  </div> */}

                  <div
                    className={`d-flex justify-content-center py-2 px-3 ${styleEnd(
                      "m",
                      2,
                    )} mb-2`}
                    style={{
                      backgroundColor: "#F2F2F2",
                      width: "fit-content",
                      borderRadius: 10,
                    }}
                  >
                    <div className={`${styleEnd("m", 2)}`}>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="18"
                        height="18"
                        viewBox="0 0 18 18"
                      >
                        <g
                          id="technical-support_1_"
                          data-name="technical-support (1)"
                          transform="translate(0 0.001)"
                        >
                          <path
                            id="Path_428"
                            data-name="Path 428"
                            d="M3.165,13.919a1.468,1.468,0,0,0-.709.181A8.3,8.3,0,0,1,10.652.867a.352.352,0,0,0,.139-.689A9.067,9.067,0,0,0,9,0,9,9,0,0,0,1.936,14.577a1.477,1.477,0,1,0,1.229-.658Zm.547,2.023a.773.773,0,1,1,.227-.547A.768.768,0,0,1,3.712,15.943Zm0,0"
                            transform="translate(0)"
                            fill={taskStatusColor}
                          />
                          <path
                            id="Path_429"
                            data-name="Path 429"
                            d="M206.6,34.346a1.473,1.473,0,1,0-.52.477,8.3,8.3,0,0,1-8.18,13.236.352.352,0,1,0-.138.69,9.073,9.073,0,0,0,1.775.175A9,9,0,0,0,206.6,34.346Zm-1.776-.272a.774.774,0,1,1,.547.226A.768.768,0,0,1,204.828,34.074Zm0,0"
                            transform="translate(-190.541 -30.925)"
                            fill={taskStatusColor}
                          />
                          <path
                            id="Path_430"
                            data-name="Path 430"
                            d="M78.932,86.445a.352.352,0,0,0,.352.352h2.2a.352.352,0,0,0,.352-.352v-.682a5.505,5.505,0,0,0,1.319-.547l.481.481a.351.351,0,0,0,.5,0l1.554-1.555a.352.352,0,0,0,0-.5l-.481-.481a5.5,5.5,0,0,0,.547-1.319h.679a.352.352,0,0,0,.352-.352V79.3a.352.352,0,0,0-.352-.352h-.679a5.505,5.505,0,0,0-.547-1.319l.478-.478a.352.352,0,0,0,0-.5L84.127,75.1a.352.352,0,0,0-.5,0l-.477.477a5.5,5.5,0,0,0-1.319-.547v-.675A.352.352,0,0,0,81.482,74h-2.2a.352.352,0,0,0-.352.352v.675a5.5,5.5,0,0,0-1.319.547l-.477-.477a.352.352,0,0,0-.5,0L75.084,76.65a.351.351,0,0,0,0,.5l.478.478a5.5,5.5,0,0,0-.547,1.319h-.678a.352.352,0,0,0-.352.351v2.2a.351.351,0,0,0,.352.352h.679a5.506,5.506,0,0,0,.547,1.319l-.481.481a.352.352,0,0,0,0,.5L76.635,85.7a.352.352,0,0,0,.249.1h0a.352.352,0,0,0,.249-.1l.481-.481a5.51,5.51,0,0,0,1.319.547Zm-1.182-1.968a.352.352,0,0,0-.439.047l-.428.428-1.057-1.058.428-.428a.351.351,0,0,0,.047-.439,4.812,4.812,0,0,1-.666-1.607.352.352,0,0,0-.344-.278h-.6v-1.5h.6a.352.352,0,0,0,.344-.278,4.812,4.812,0,0,1,.666-1.607.351.351,0,0,0-.047-.439l-.425-.425,1.058-1.057.424.425a.352.352,0,0,0,.439.047,4.81,4.81,0,0,1,1.607-.666.352.352,0,0,0,.278-.344v-.6h1.5v.6a.351.351,0,0,0,.278.344,4.814,4.814,0,0,1,1.607.666.351.351,0,0,0,.439-.047l.425-.424L84.937,76.9l-.425.425a.351.351,0,0,0-.047.439,4.815,4.815,0,0,1,.666,1.607.351.351,0,0,0,.344.278h.6v1.5h-.6a.352.352,0,0,0-.344.278,4.811,4.811,0,0,1-.666,1.607.352.352,0,0,0,.047.439l.428.428-1.057,1.058-.428-.428a.351.351,0,0,0-.439-.047,4.815,4.815,0,0,1-1.607.666.352.352,0,0,0-.278.344v.607h-1.5v-.607a.352.352,0,0,0-.278-.344A4.812,4.812,0,0,1,77.751,84.477Zm0,0"
                            transform="translate(-71.384 -71.399)"
                            fill={taskStatusColor}
                          />
                          <path
                            id="Path_431"
                            data-name="Path 431"
                            d="M179.181,176.276a2.9,2.9,0,1,0-2.9,2.9A2.908,2.908,0,0,0,179.181,176.276Zm-5.107,0a2.2,2.2,0,1,1,2.2,2.2A2.2,2.2,0,0,1,174.074,176.276Zm0,0"
                            transform="translate(-167.277 -167.277)"
                            fill={taskStatusColor}
                          />
                          <path
                            id="Path_432"
                            data-name="Path 432"
                            d="M338.43,18.512a.352.352,0,1,0-.248-.1A.354.354,0,0,0,338.43,18.512Zm0,0"
                            transform="translate(-326.193 -17.183)"
                            fill={taskStatusColor}
                          />
                          <path
                            id="Path_433"
                            data-name="Path 433"
                            d="M154.711,474.359a.352.352,0,1,0,.249.1A.355.355,0,0,0,154.711,474.359Zm0,0"
                            transform="translate(-148.933 -457.683)"
                            fill={taskStatusColor}
                          />
                        </g>
                      </svg>
                    </div>
                    <div className="d-flex align-items-center justify-content-center">
                      <p className="my-0">{taskStatusName}</p>
                    </div>
                  </div>

                  <div
                    className={`d-flex justify-content-center py-2 px-3 ${styleEnd(
                      "m",
                      2,
                    )} mb-2`}
                    style={{
                      backgroundColor: "#F2F2F2",
                      width: "fit-content",
                      borderRadius: 10,
                    }}
                  >
                    <div className={`${styleEnd("m", 2)}`}>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="14.541"
                        viewBox="0 0 16 14.541"
                      >
                        <g
                          id="Group_303"
                          data-name="Group 303"
                          transform="translate(-708 -230.459)"
                        >
                          <path
                            id="Path_344"
                            data-name="Path 344"
                            d="M12.108,35a2.108,2.108,0,1,0,2.108,2.108A2.108,2.108,0,0,0,12.108,35Zm0,3.3a1.171,1.171,0,1,1,1.171-1.171A1.171,1.171,0,0,1,12.108,38.3Z"
                            transform="translate(700.57 203.164)"
                            fill={item?.priority?.color}
                          />
                          <path
                            id="Path_345"
                            data-name="Path 345"
                            d="M9.529,5A6.436,6.436,0,0,0,3.1,11.246l-.582-.417a.5.5,0,0,0-.645.052L.852,11.906A.5.5,0,0,0,.8,12.55l.5.712-.055.135-.867.145a.5.5,0,0,0-.417.5v1.444a.5.5,0,0,0,.417.5l.867.145.055.135-.5.712a.5.5,0,0,0,.052.645l1.024,1.024a.5.5,0,0,0,.645.052l.715-.5.132.055.145.869a.5.5,0,0,0,.5.417H5.456a.5.5,0,0,0,.5-.417l.145-.869.132-.055.715.5a.5.5,0,0,0,.645-.052l.847-.879A6.43,6.43,0,1,0,9.529,5ZM7.158,16.588,7.6,17.2l-.422.422-.612-.437a.5.5,0,0,0-.532-.035,2.683,2.683,0,0,1-.535.225.5.5,0,0,0-.345.395l-.125.75H4.43l-.125-.75a.5.5,0,0,0-.337-.395,2.683,2.683,0,0,1-.535-.225.5.5,0,0,0-.532.035l-.62.437L1.859,17.2l.437-.612a.5.5,0,0,0,.032-.535,2.581,2.581,0,0,1-.22-.527.5.5,0,0,0-.39-.35l-.75-.125v-.595l.75-.125a.5.5,0,0,0,.39-.337,2.581,2.581,0,0,1,.22-.527.5.5,0,0,0-.032-.535l-.437-.625.422-.422.612.437a.5.5,0,0,0,.535.032,2.581,2.581,0,0,1,.54-.22.5.5,0,0,0,.337-.39L4.43,11h.595l.125.75a.5.5,0,0,0,.35.4,2.581,2.581,0,0,1,.527.22.5.5,0,0,0,.535-.032l.612-.437.422.422-.437.6a.5.5,0,0,0-.035.532,2.683,2.683,0,0,1,.225.535.5.5,0,0,0,.395.345l.75.125v.595l-.75.125a.5.5,0,0,0-.395.345,2.683,2.683,0,0,1-.225.535.5.5,0,0,0,.035.532Zm2.371.275a5.5,5.5,0,0,1-1.014-.1l-.372-.522c.02-.042.037-.087.055-.132l.869-.145a.5.5,0,0,0,.417-.5V14.032a.5.5,0,0,0-.417-.5L8.2,13.387c-.017-.045-.035-.09-.055-.132l.5-.715a.5.5,0,0,0-.052-.645L7.565,10.871a.5.5,0,0,0-.645-.052l-.712.5-.135-.055L5.929,10.4a.5.5,0,0,0-.5-.417H4.29a5.432,5.432,0,1,1,5.247,6.866Z"
                            transform="translate(708.04 225.459)"
                            fill={item?.priority?.color}
                          />
                          <path
                            id="Path_346"
                            data-name="Path 346"
                            d="M37.2,15.108V11.048a.468.468,0,0,0-.937,0V15.3a.468.468,0,0,0,.138.33L38.2,17.438a.47.47,0,0,0,.661-.67Z"
                            transform="translate(680.936 221.186)"
                            fill={item?.priority?.color}
                          />
                        </g>
                      </svg>
                    </div>
                    <div className="d-flex align-items-center justify-content-center">
                      <p className="my-0">{item?.priority?.name}</p>
                    </div>
                  </div>

                  {/* <div
                    className={`d-flex py-2 px-3 mb-2 text-decoration-none text-dark ms-2`}
                    style={{
                      backgroundColor: "#F2F2F2",
                      width: 165,
                      height: 40,
                      borderRadius: 10,
                    }}
                  >
                    <li
                      className="d-flex"
                      style={{
                        position: "relative",
                        left: "-45% !important",
                        top: "-185% !important",
                        width: "inherit",
                      }}
                    >
                      <div
                        className={`d-flex justify-content-center align-items-center ${styleEnd(
                          "m",
                          2
                        )}`}
                        style={{
                          border: "1px solid #1A73E8",
                          backgroundColor: "#1A73E8",
                          color: "white",
                          borderRadius: "50%",
                          width: 24,
                          height: 24,
                          fontSize: 12,
                        }}
                      >
                        {item.subTasksCount ?? 0}
                      </div>
                      <div className="d-flex align-items-center justify-content-center">
                        <p className="my-0">
                          {item.subTasksCount > 1
                            ? "الإجراءات فرعية"
                            : "الإجراءات فرعي"}
                        </p>
                      </div>
                    </li>
                  </div> */}

                  {/* <Link
                    className="d-flex justify-content-center py-2 px-3 mb-2 text-decoration-none text-dark"
                    style={{
                      backgroundColor: "#F2F2F2",
                      width: "fit-content",
                      borderRadius: 10,
                    }}
                    to={`/taskDetails/${item.id}`}
                  >
                    <div className="hoverLinks d-flex">
                      <div
                        className={`d-flex justify-content-center align-items-center ${styleEnd(
                          "m",
                          2
                        )}`}
                        style={{
                          border: "1px solid #1A73E8",
                          backgroundColor: "#1A73E8",
                          color: "white",
                          borderRadius: "50%",
                          width: 24,
                          height: 24,
                          fontSize: 12,
                        }}
                      >
                        {item.procedureCount ?? 0}
                      </div>
                      <div className="d-flex align-items-center justify-content-center">
                        <p className="my-0">
                          {item.procedureCount > 1
                            ? Lang.procedures
                            : Lang.procedure}
                        </p>
                      </div>
                    </div>
                  </Link> */}

                  <div
                    className={`d-flex py-2 px-3 mb-2 text-decoration-none text-dark ${styleStart(
                      "m",
                      2,
                    )}`}
                    style={{
                      backgroundColor: "#F2F2F2",
                      width: 140,
                      height: 40,
                      borderRadius: 10,
                    }}
                  >
                    <li
                      className="d-flex"
                      style={{
                        position: "relative",
                        left: "-45% !important",
                        top: "-185% !important",
                        position: "absolute",
                        width: "inherit",
                      }}
                      data-tip
                      data-for={customStyle(`accesslevel-${item.id}`)}
                    >
                      <div className={`${styleEnd("m", 2)}`}>
                        {item?.accessLevelId == 1 && (
                          <img
                            src="/assets/images/coo1.png"
                            style={{ width: "18px" }}
                          />
                        )}
                        {item?.accessLevelId == 2 && (
                          <img
                            src="/assets/images/coo2.png"
                            style={{ width: "18px" }}
                          />
                        )}
                        {item?.accessLevelId == 3 && (
                          <img
                            src="/assets/images/coo3.png"
                            style={{ width: "18px" }}
                          />
                        )}
                        <li
                          className="d-flex"
                          style={{
                            position: "relative",
                            left: "-45% !important",
                            top: "-185% !important",
                            position: "absolute",
                            width: "inherit",
                          }}
                          data-tip
                          data-for={customStyle(`accesslevel-${item.id}`)}
                        ></li>
                      </div>
                      {item?.countries?.length > 0 && (
                        <ReactTooltip
                          id={customStyle(`accesslevel-${item.id}`)}
                          type="info"
                          effect="solid"
                          place={"top"}
                          backgroundColor="rgb(12, 87, 76)"
                          arrowColor="rgb(12, 87, 76)"
                        >
                          <span>
                            {item?.countries?.length ? (
                              item?.countries?.map((item, index) => {
                                return (
                                  <div>
                                    {item.countryName}
                                    <br />
                                  </div>
                                );
                              })
                            ) : (
                              <></>
                            )}
                          </span>
                        </ReactTooltip>
                      )}

                      <div className="d-flex align-items-center justify-content-center">
                        <p className="my-0">{item?.accessLevelName}</p>
                      </div>
                    </li>
                  </div>
                  {/* <div
                    className={`d-flex py-2 px-3 mb-2 text-decoration-none text-dark ${styleStart(
                      "m",
                      2
                    )}`}
                    style={{
                      backgroundColor: "#F2F2F2",
                      width: 140,
                      height: 40,
                      borderRadius: 10,
                    }}
                  >
                    <li
                      className="d-flex"
                      style={{
                        position: "relative",
                        left: "-45% !important",
                        top: "-185% !important",
                        position: "absolute",
                        width: "inherit",
                      }}
                      data-tip
                      data-for={customStyle(`liMembers-${item.id}`)}
                    >
                      <ReactTooltip>
                        <span>
                          {item?.members?.length ? (
                            item?.members?.map((item, index) => {
                              return (
                                <div>
                                  {item.memberName}
                                  <br />
                                </div>
                              );
                            })
                          ) : (
                            <></>
                          )}
                        </span>
                      </ReactTooltip>

                      <div className="d-flex align-items-center justify-content-center">
                        <p className="my-0">{item?.accessLevelName}</p>
                      </div>
                    </li>
                  </div> */}

                  <div
                    className={`d-flex py-2 px-3 mb-2 text-decoration-none text-dark ${styleStart(
                      "m",
                      2,
                    )}`}
                    style={{
                      backgroundColor: "#F2F2F2",
                      width: 140,
                      height: 40,
                      borderRadius: 10,
                    }}
                  >
                    <li
                      className="d-flex"
                      style={{
                        position: "relative",
                        left: "-45% !important",
                        top: "-185% !important",
                        position: "absolute",
                        width: "inherit",
                      }}
                      data-tip
                      data-for={customStyle(`liMembers-${item.id}`)}
                    >
                      <ReactTooltip
                        id={customStyle(`liMembers-${item.id}`)}
                        type="info"
                        effect="solid"
                        place={"top"}
                        backgroundColor="rgb(12, 87, 76)"
                        arrowColor="rgb(12, 87, 76)"
                      >
                        <span>
                          {item?.members?.length ? (
                            item?.members?.map((item, index) => {
                              return (
                                <div>
                                  {item.memberName}
                                  <br />
                                </div>
                              );
                            })
                          ) : (
                            <></>
                          )}
                        </span>
                      </ReactTooltip>
                      <div
                        className={`d-flex justify-content-center align-items-center ${styleEnd(
                          "m",
                          2,
                        )}`}
                        style={{
                          border: "1px solid rgb(12, 87, 76)",
                          backgroundColor: "rgb(12, 87, 76)",
                          color: "white",
                          borderRadius: "50%",
                          width: 24,
                          height: 24,
                          fontSize: 12,
                        }}
                      >
                        {item.memberCount ?? 0}
                      </div>
                      <div className="d-flex align-items-center justify-content-center">
                        <p className="my-0">
                          {item.memberCount > 1 ? Lang.Members : Lang.Member}
                        </p>
                      </div>
                    </li>
                  </div>
                </div>

                {/* procedures section */}
                <div
                  style={{
                    backgroundColor: "#F2F2F2",
                    borderRadius: 10,
                  }}
                >
                  <div
                    className={`d-flex mx-4 py-2 align-items-center ${styleStart(
                      "p",
                      5,
                      "md",
                    )} ${styleStart("p", 4, "xl")}`}
                  >
                    <span className="text-muted" style={{ fontSize: 15 }}>
                      {item.procedureCount > 0
                        ? Lang.lastcommentWasAdded
                        : Lang.thereIsNocomments}
                    </span>
                    <hr
                      className="col-md-3 col-lg-5 col-xl-7 mx-2 d-none d-sm-block"
                      style={{ backgroundColor: "#707070" }}
                    ></hr>
                    <div
                      className={`d-flex align-items-center col ${
                        getDir(getCurrentLangFromRedux()) === "rtl"
                          ? contentStart("justify-content")
                          : contentEnd("justify-content")
                      } ${
                        getDir(getCurrentLangFromRedux()) === "rtl"
                          ? contentEnd("justify-content", "md")
                          : contentStart("justify-content", "md")
                      }`}
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        setTaskId(item.id);
                        setVisibleProc(true);
                      }}
                    >
                      <div
                        style={{
                          backgroundColor: "#0c574b",
                          height: 26,
                          width: 26,
                          cursor: "pointer",
                          borderRadius: "50%",
                        }}
                        className="d-flex justify-content-center text-center align-items-center itemNav plusIcon"
                      >
                        <div
                          style={{
                            width: 16,
                            height: 16,
                            background:
                              "url('/assets/images/icons/Path 184.png') 0% 0% no-repeat padding-box",
                            opacity: 1,
                            filter: "opacity(1) brightness(20)",
                          }}
                          className="any"
                        ></div>
                      </div>
                      <span className="mx-2">{Lang.addcomments}</span>
                    </div>
                  </div>

                  {item.procedure ? (
                    <>
                      <div className="d-flex flex-md-row flex-column px-4 align-items-center">
                        <div className="d-flex align-items-center justify-content-md-start justify-content-center my-2 col-12 col-md-7">
                          <div
                            style={{
                              backgroundImage: userPhoto,
                              width: 40,
                              height: 40,
                              borderRadius: "50%",
                              backgroundPosition: "center",
                              backgroundRepeat: "no-repeat",
                              backgroundSize: "cover",
                              border: "1px solid white",
                            }}
                          ></div>
                          <p
                            className="mx-2 my-0"
                            style={{ fontWeight: "bold" }}
                          >
                            {item.procedure.memberName}
                          </p>
                        </div>
                        <div className="col-12 col-md-4 col-xl-5 d-flex px-xl-4 my-2 justify-content-md-end justify-content-center">
                          <span
                            className={`text-muted ${styleStart(
                              "m",
                              0,
                            )} ${styleEnd("m", 4, "md")} `}
                            style={{ fontSize: 14 }}
                          >
                            {`${formatDatelll(newCreateDate)}`}
                          </span>
                        </div>
                      </div>

                      <div
                        className="d-flex px-md-5 mx-4 align-items-center"
                        style={{
                          textAlign: "justify",
                          fontSize: 16,
                          color: "#444444",
                        }}
                      >
                        <p>{item.procedure.description}</p>
                      </div>

                      {/* add Comment section */}
                      {/* <div className="d-flex px-5 mx-5 mb-2">
                        <div
                          style={{
                            width: 1,
                            height: 25,
                            backgroundColor: "#707070",
                          }}
                        ></div>
                        <div
                          className="mt-4"
                          style={{
                            width: 10,
                            height: 1,
                            backgroundColor: "#707070",
                          }}
                        ></div>
                        <div
                          className="d-flex justify-content-center py-2 px-3"
                          style={{ cursor: "pointer" }}
                        >
                          <div>
                            <svg
                              id="fi-br-comment-alt"
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="15.851"
                              viewBox="0 0 16 15.851"
                            >
                              <path
                                id="Path_74"
                                data-name="Path 74"
                                d="M12.333,0H3.667A3.671,3.671,0,0,0,0,3.667v6a3.671,3.671,0,0,0,3.667,3.667h.959l2.733,2.285a1,1,0,0,0,1.283,0l2.733-2.285h.959A3.671,3.671,0,0,0,16,9.667v-6A3.671,3.671,0,0,0,12.333,0ZM14,9.667a1.667,1.667,0,0,1-1.667,1.667H11.011a1,1,0,0,0-.641.233L8,13.548,5.63,11.567a1,1,0,0,0-.641-.233H3.667A1.667,1.667,0,0,1,2,9.667v-6A1.667,1.667,0,0,1,3.667,2h8.667A1.667,1.667,0,0,1,14,3.667Z"
                                fill="#1a73e8"
                              />
                              <path
                                id="Path_75"
                                data-name="Path 75"
                                d="M7.167,8.333H9.5A1.167,1.167,0,0,0,9.5,6H7.167a1.167,1.167,0,0,0,0,2.333Z"
                                transform="translate(-2.667 -2.289)"
                                fill="#1a73e8"
                              />
                              <path
                                id="Path_76"
                                data-name="Path 76"
                                d="M14.853,11H7.265a1.265,1.265,0,0,0,0,2.529h7.588a1.265,1.265,0,0,0,0-2.529Z"
                                transform="translate(-3 -3.196)"
                                fill="#1a73e8"
                              />
                            </svg>
                          </div>
                          <div className="d-flex col-12 align-items-center justify-content-center">
                            <p className="my-0">إضافة ملاحظة</p>
                          </div>
                        </div>
                      </div>  */}
                    </>
                  ) : null}
                </div>
              </div>
            );
          })}
          {renderAttachmentsModal(taskId)}
        </div>
      </>
    );
  } else {
    return <div></div>;
  }
};

export default TaskCard;
